import classNames from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import securityCodeImage from '../../../../public/static/books/security-code.png';

import css from './SecurityCodeMessage.module.scss';

const SecurityCodeMessage = () => {
  const intl = useIntl();
  const classes = classNames(css.SecurityCodeMessage);

  return (
    <div className={classes}>
      <img
        className={css.SecurityCodeMessage__Img}
        src={securityCodeImage}
        alt="Security Code"
      />
      <p className={css.SecurityCodeMessage__Text}>
        {intl.formatMessage({ id: 'securityCodeMessage.message' })}
      </p>
    </div>
  );
};

export default SecurityCodeMessage;
